/*  ========================================================================
    # Hooks - Use API Search Public
    ========================================================================  */

/* eslint-disable prettier/prettier */

import { useEffect, useState } from 'react';

const useApiSearchPublic = (categories, location, distance) => {
  const [loadingSearchResults, setLoadingSearchResults] = useState(false);
  const [errorLoadingSearchResults, setErrorLoadingSearchResults] = useState(false);
  const [searchResults, setSearchResults] = useState([]);

  // Get location values.
  const zipValue = location?.match(/\b\d{5}\b/g)?.join('');
  const locationValue = location?.match(/\D+/g)?.join('')?.trim();
  let latitudeValue = null;
  let longitudeValue = null;
  if (zipValue === null && locationValue === null) {
    const coords = location.split(',');
    latitudeValue = coords[0];
    longitudeValue = coords[1];
  }

  // Fetch API and map response.
  const getSearchResults = async () => {
    setLoadingSearchResults(true);

    // Construct search params.
    const searchParams = new URLSearchParams();
    if (categories?.length > 0) {
      categories.forEach(category => searchParams.append('Interests', category.name));
    }
    if (zipValue && !latitudeValue && !longitudeValue) searchParams.append('Zip', zipValue);
    if (locationValue && !latitudeValue && !longitudeValue) searchParams.append('Location', locationValue);
    if (latitudeValue && !zipValue && !locationValue) searchParams.append('Latitude', latitudeValue);
    if (longitudeValue && !zipValue && !locationValue) searchParams.append('Longitude', longitudeValue);
    if (distance > 1) searchParams.append('Distance', distance);

    try {
      const response = await fetch(`${process.env.EVM_EB_API}/search/public?${searchParams.toString()}&subscription-key=657b98dfa5b948dfb40b037a3bd4c7b7`);

      if (response.status !== 200) throw new Error(await response.text());

      const results = await response.json();

      // Map offers array.
      const offers = [];
      results.offers.forEach(offer => {
        offer.campaign = offer.campaignId !== null ? results.campaigns.find(campaign => campaign.id === offer.campaignId) : { title: 'weitere' };
        offers.push(offer);
      });

      setLoadingSearchResults(false);
      setSearchResults(offers);
    } catch (error) {
      setLoadingSearchResults(false);
      setErrorLoadingSearchResults(true);
      console.log(error); // eslint-disable-line
    }
  };

  useEffect(() => {
    if (categories.length > 0 || zipValue || locationValue || latitudeValue && longitudeValue) {
      getSearchResults();
    } else {
      setSearchResults([]);
    }
  }, [categories, location, distance]);

  return { loadingSearchResults, errorLoadingSearchResults, searchResults };
};

export default useApiSearchPublic;
